import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema } from './schemas/screenSchema';

export const influencersChannelsSearchParams = new SearchParams(screenSchema);

export const influencersChannelsLink = new Link(
  'influencers-channels',
  influencersChannelsSearchParams
);

export const influencersChannelsDetailsLink = influencersChannelsLink.child(
  ':id'
);
